/* eslint-disable no-restricted-globals */
import { useDispatch, useSelector } from 'react-redux'

import saga from 'Modules/auth/store/saga'
import reducer from 'Modules/auth/store/reducer'
import {
  changePassword,
  login,
  loginGoogleSSO,
  loginMSSSO,
  logOut,
  registerBasic,
  registerBasicInvite,
  registerEnterprise,
  registerGoogleSSO,
  registerReSendEmail,
  registerWithPayment,
  resetPasswordSendMail
} from 'Modules/auth/store/actions'
import { useInjectReducer, useInjectSaga } from 'Stores'
import { makeSelectAuthentication } from 'Modules/auth/store/selectors'
import { ROLE_TYPE } from '../Constants/permission'

export const useAuth = () => {
  useInjectSaga({ key: 'auth', saga })
  useInjectReducer({ key: 'auth', reducer })

  const { isCheck2FA, isEnable2FA, isLoading, error, authenticated, profile, metaData, success } = useSelector(
    makeSelectAuthentication()
  )

  const dispatch = useDispatch()
  const registerGoogleSSOAction = (payload) => dispatch(registerGoogleSSO(payload))
  const registerBasicAction = (payload) => dispatch(registerBasic(payload))
  const registerBasicInviteAction = (payload) => dispatch(registerBasicInvite(payload))
  const registerWithPaymentAction = (payload) => dispatch(registerWithPayment(payload))
  const postReSendSignUpEmailAction = (payload) => dispatch(registerReSendEmail(payload))
  const loginAction = (payload) => dispatch(login(payload))
  const logOutAction = (payload) => dispatch(logOut(payload))
  const loginGoogleSSOAction = (payload) => dispatch(loginGoogleSSO(payload))
  const loginMSSSOAction = (payload) => dispatch(loginMSSSO(payload))
  const resetPasswordSendMailAction = (payload) => dispatch(resetPasswordSendMail(payload))
  const changePasswordAction = (payload) => dispatch(changePassword(payload))
  const registerEnterpriseAction = (payload) => dispatch(registerEnterprise(payload))

  return {
    isCheck2FA,
    isEnable2FA,
    isLoading,
    error,
    authenticated,
    profile,
    metaData,
    success,
    registerGoogleSSOAction,
    registerBasicAction,
    registerBasicInviteAction,
    registerWithPaymentAction,
    postReSendSignUpEmailAction,
    loginAction,
    loginGoogleSSOAction,
    loginMSSSOAction,
    logOutAction,
    resetPasswordSendMailAction,
    changePasswordAction,
    registerEnterpriseAction
  }
}

export const useRoles = () => {
  useInjectSaga({ key: 'auth', saga })
  useInjectReducer({ key: 'auth', reducer })

  const { profile } = useSelector(
    makeSelectAuthentication()
  )

  const isSystemAdmin = profile.role.includes(ROLE_TYPE.SYSTEM_ADMIN)
  const isCompanyAdmin = profile.role.includes(ROLE_TYPE.COMPANY_ADMIN)
  const isPortfolioAdmin = profile.role.includes(ROLE_TYPE.PORTFOLIO_ADMIN)
  const isEditor = profile.role.includes(ROLE_TYPE.EDITOR)
  const isUser = profile.role.includes(ROLE_TYPE.USER)

  return { isSystemAdmin, isCompanyAdmin, isPortfolioAdmin, isEditor, isUser }
}
